module.exports = __webpack_public_path__ + "media/images/LenovoLogoRed-63e82deed39e4c259762602bef54551d.jpg";